import { AbstractControl, UntypedFormGroup, ValidationErrors } from '@angular/forms';
import { SchedulingType } from '../../../../../common/constants/scheduling-type';
import { getMinutesOfDayFromFormValue } from '../../../../../common/utils/date.helpers';
import { addDays, startOfDay } from 'date-fns';

export enum CompartmentRuleTimeFrameEnum {
  StartTime = 'startTime',
  EndTime = 'endTime',
}

export function activityTypeValidator(): (activityTypesControl: AbstractControl) => ValidationErrors {
  return (activityTypesControl: AbstractControl) => {
    return activityTypesControl.value?.length ? null : { required: true };
  };
}

export function timeRangeValidator(_key: CompartmentRuleTimeFrameEnum): (control: AbstractControl) => ValidationErrors {
  return (control: AbstractControl): ValidationErrors => {
    const parent = control.parent as UntypedFormGroup;

    if (!parent) {
      return null;
    }

    const { startTime, endTime } = parent.controls;

    if (!startTime.value || !endTime.value) {
      return null;
    }

    const startTimeInMinutes: number = getMinutesOfDayFromFormValue(startTime.value);
    const endTimeInMinutes: number = getMinutesOfDayFromFormValue(endTime.value);

    return startTimeInMinutes === endTimeInMinutes ? { invalidTimeRange: true } : null;
  };
}

export function schedulingTypeValidator(control: AbstractControl): ValidationErrors {
  const value = control.value;
  const parent = control.parent as UntypedFormGroup;

  if (parent) {
    const { day } = parent.controls;
    if (value === SchedulingType.Weekly) {
      day.enable();
    } else {
      day.setValue([], { emitEvent: false });
      day.disable();
    }
  }

  return null;
}

export function futureDateValidator(control: AbstractControl): ValidationErrors {
  if (!control.value) {
    return null;
  }
  const selected = startOfDay(new Date(control.value));
  const minAllowed = startOfDay(addDays(new Date(), 1));
  return selected.getTime() >= minAllowed.getTime() ? null : { pastDate: true };
}

export function sapValidator(
  deliveryAddressesControl: AbstractControl,
): (sapControl: AbstractControl) => ValidationErrors {
  return (sapControl: AbstractControl) => {
    const value = sapControl.value;
    const parent = sapControl.parent;
    if (parent && deliveryAddressesControl) {
      if (value && value?.length) {
        deliveryAddressesControl.clearValidators();
        deliveryAddressesControl.updateValueAndValidity({ emitEvent: false });

        if (!deliveryAddressesControl.value?.length) {
          deliveryAddressesControl.disable({ emitEvent: false });
        }
      } else {
        deliveryAddressesControl.enable();
        deliveryAddressesControl.updateValueAndValidity();
      }
    }

    return deliveryAddressesControl?.value?.length && sapControl?.value?.length
      ? { deliveryAddressOrAddressPointShouldBeEmpty: true }
      : null;
  };
}
